module.exports = __webpack_public_path__ + "img/skeleton_2.810e40d9.png";